import { useState, useEffect } from "react";
// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import { baseUrl, baseUrladmin } from "../../../assets/js/config/config.js";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import axios from "axios";
import { useLocation } from "react-router-dom";
import "../style.css";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";

function EditCustomer() {
    const AccessToken = localStorage.getItem("accessToken");
    const { register, handleSubmit, formState: { errors } } = useForm();
    const navigate = useNavigate();
    const [Check, setCheck] = useState();
    const [companytypes, setCompanytypes] = useState([]);
    const [cmptype, setcmptype] = useState();
    const [editdata, setEditdata] = useState([]);
    const { state } = useLocation();

    const handlSelect = (e) => {
        setcmptype(e.target.value);
    }

    useEffect(() => {
        fetch(baseUrladmin + "comptypes/getAllCompanyTypes", {
            headers: {
                Authorization: `Bearer ${AccessToken}`,
                "Content-type": "application/json; charset=UTF-8",
                "companyId": localStorage.getItem("companyId"),
            },
        })
            .then((response) => response.json())
            .then((data) => {
                setCompanytypes(data.data);
            })
            .catch((err) => {
                console.log(err.message);
            });
            const bodyFormData = {
                companyMasterId: state.companyMasterId,
                companyId: localStorage.getItem("companyId"),
            };
            axios({
                method: "post",
                url: baseUrladmin + "company/getCompanyMasterById",
                data: bodyFormData,
                config: {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json; charset=utf-8",
                    },
                },
            }).then((response) => response)
                .then((data) => {
                    setEditdata(data.data.data);
                })
                .catch((err) => {
                    console.log(err.message);
                });
    }, []);
    const onSubmit = (data) => {
        const bodyFormData = {
            "companyId": editdata.companyId,
            "active": Check ? Check : false ,
            "balanceAmount": data.balanceAmount ? data.balanceAmount : editdata.balanceAmount,
            "companyAddress": data.companyAddress ? data.companyAddress : editdata.companyAddress,
            "companyCIN": data.companyCIN ? data.companyCIN : editdata.companyCIN,
            "companyContactEmail": data.companyContactEmail ? data.companyContactEmail : editdata.companyContactEmail,
            "companyContactMobile": data.companyContactMobile ? data.companyContactMobile : editdata.companyContactMobile,
            "companyContactName": data.companyContactName ? data.companyContactName : editdata.companyContactName,
            "companyContactPhone": data.companyContactPhone ? data.companyContactPhone : editdata.companyContactPhone,
            "companyEmail": data.companyEmail ? data.companyEmail : editdata.companyEmail,
            "companyGST": data.companyGST ? data.companyGST : editdata.companyGST,
            "companyName": data.companyName ? data.companyName : editdata.companyName,
            "companyPhone": data.companyPhone ? data.companyPhone : editdata.companyPhone,
            "companyTin": data.companyTin ? data.companyTin : editdata.companyTin,
            "companyType": data.companyType ? data.companyType : editdata.companyType,
            "companyTypeId": cmptype,
            "country": data.country ? data.country : editdata.country,
            "postalCode": data.postalCode ? data.postalCode : editdata.postalCode,
            "stateName": data.stateName ? data.stateName : editdata.stateName,
        };
        axios({
            method: "put",
            url: baseUrladmin + "company/updateCompanyMaster",
            data: bodyFormData,
            config: {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json; charset=utf-8",
                },
            },
        })
            .then((data) => {
                if (data.data.status == 200) {
                    alert("Customer Updated Successfully");
                    navigate("/customers");
                }
                else {
                    alert(data.data.message);
                    window.location.reload(false);
                }
            })
            .catch((err) => {
                console.log(err.message);
            });
    }
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <Grid container spacing={6}><Grid item xs={12}>
                <Card>
                    <MDBox
                        mx={2}
                        mt={3}
                        py={3}
                        px={2}
                        variant="gradient"
                        bgColor="info"
                        borderRadius="lg"
                        coloredShadow="info"
                    >
                        <MDTypography variant="h6" color="white">
                            Edit Customer
                        </MDTypography>
                    </MDBox>
                    <div className='App container fpd col-6'>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className='row' style={{ width: "965px" }}>
                                <div className='mb-1'>
                                    <label htmlFor='companyName'>Name</label>
                                    <input
                                        className={`form-control ${errors.companyName ? 'is-invalid' : ''}`}
                                        type='text'
                                        name='companyName'  defaultValue={editdata.companyName}
                                        {...register("companyName", { required: true })}
                                    />
                                </div>
                                <div className='mb-1'>
                                    <label htmlFor='companyPhone'>Phone</label>
                                    <input
                                        className={`form-control ${errors.companyPhone ? 'is-invalid' : ''}`}
                                        type='text'
                                        name='companyPhone' defaultValue={editdata.companyPhone}
                                        {...register("companyPhone", { required: true, pattern: { value: /[7-9][0-9]{9}$/i } })}
                                    />
                                </div>
                                
                                <div className='mb-1'>
                                    <label htmlFor='companyEmail'>Email</label>
                                    <input
                                        className={`form-control ${errors.companyEmail ? 'is-invalid' : ''}`}
                                        type='text'
                                        name='companyEmail'
                                        defaultValue={editdata.companyEmail}
                                        {...register("companyEmail", { required: true })}
                                    />
                                </div>
                                
                                <div className='mb-1'>
                                    <label htmlFor='stateName'>State Name</label>
                                    <input
                                        className='form-control'
                                        type='text'
                                        name='stateName'
                                        defaultValue={editdata.stateName}
                                        {...register("stateName")}
                                    />
                                </div>
                            </div>

                            <div className='row' style={{ width: "965px" }}>
                                <div className='mb-1'>
                                    <label htmlFor='country'>Country</label>
                                    <input
                                        className='form-control'
                                        type='text'
                                        name='country'
                                        defaultValue={editdata.country}
                                        {...register("country")}
                                    />
                                </div>
                                <div className='mb-1'>
                                    <label htmlFor='postalCode'>Postal Code</label>
                                    <input
                                        className='form-control'
                                        type='text'
                                        name='postalCode'
                                        defaultValue={editdata.postalCode}
                                        {...register("postalCode")}
                                    />
                                </div>

                                
                                <div className='mb-1'>
                                    <label htmlFor='companyTin'>Tin</label>
                                    <input
                                        className='form-control'
                                        type='text'
                                        name='companyTin'
                                        defaultValue={editdata.companyTin}
                                        {...register("companyTin")}
                                    />
                                </div>
                                <div className='mb-1'>
                                    <label htmlFor='companyType'>Company Type</label>
                                    <select defaultValue={editdata.companyTypeId}  onChange={handlSelect} style={{ "width": "216px" }}>
                                        {companytypes.map((companytype) => (
                                            <option value={companytype.companyTypeId}>{companytype.companyType}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className='row' style={{ width: "965px" }}>
                                <div className='mb-1'>
                                    <label htmlFor='companyGST'>GST</label>
                                    <input
                                        className='form-control'
                                        type='text'
                                        name='companyGST'
                                        defaultValue={editdata.companyGST}
                                        {...register("companyGST")}
                                    />
                                </div>
                                <div className='mb-1'>
                                    <label htmlFor='balanceAmount'>Balance Amount</label>
                                    <input
                                        className='form-control'
                                        type='text'
                                        name='balanceAmount'
                                        defaultValue={editdata.balanceAmount}
                                        {...register("balanceAmount")}
                                    />
                                </div>
                                <div className='mb-1'>
                                    <label htmlFor='companyContactName'>Contact Name</label>
                                    <input
                                        className='form-control'
                                        type='text'
                                        name='companyContactName'
                                        defaultValue={editdata.companyContactName}
                                        {...register("companyContactName")}
                                    /> 
                                </div>
                                
                                <div className='mb-1'>
                                    <label htmlFor='companyContactMobile'>Contact Mobile</label>
                                    <input
                                        className='form-control'
                                        type='text'
                                        name='companyContactMobile'
                                        defaultValue={editdata.companyContactMobile}
                                        {...register("companyContactMobile")}
                                    />
                                </div>
                            </div>
                            <div className='row' style={{ width: "965px" }}>
                                <div className='mb-1'>
                                    <label htmlFor='companyContactEmail'>Contact Email</label>
                                    <input
                                        className='form-control'
                                        type='text'
                                        name='companyContactEmail'
                                        defaultValue={editdata.companyContactEmail}
                                        {...register("companyContactEmail")}
                                    />
                                </div>
                                <div className='mb-1'>
                                    <label htmlFor='companyCIN'>Company CIN</label>
                                    <input
                                        className='form-control'
                                        type='text'
                                        name='companyCIN'
                                        defaultValue={editdata.companyCIN}
                                        {...register("companyCIN")}                                      
                                    />
                                </div>
                                <div className='mb-1'>
                                    <label htmlFor='companyAddress'>Company Address</label>
                                    <input
                                        className='form-control'
                                        type='text'
                                        name='companyAddress'
                                        defaultValue={editdata.companyAddress}
                                        {...register("companyAddress")} 
                                    />
                                </div>
                                
                                <div className='mb-1'>
                                    <input type="checkbox" defaultChecked={editdata.active} id="active" name="active" onChange={(e) => setCheck(e.target.checked)} />
                                    <label for="active"> Is Active</label>
                                </div>
                            </div>
                            <div className='mb-3'>
                                <MDButton variant="outlined" type="submit" color="info" size="small">
                                    Update
                                </MDButton>
                            </div>
                        </form>
                    </div>
                </Card>
            </Grid>
            </Grid>
        </DashboardLayout>
    );
}

export default EditCustomer;
